<ul class="layout-menu z1k">
  @for (item of sidebarItemsComputed(); track i; let i = $index) {
  @if (!item.separator) {
  <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
  }
  @if (item.separator) {
  <li class="menu-separator"></li>
  }
  }
</ul>

<p-dialog header="About" [(visible)]="visible" styleClass="w-6/12 lg:w-3/12 notifications-accordion" [draggable]="false"
  appendTo="body" [contentStyle]="{'overflow': 'visible'}">
  <div class="flex justify-between py-2">
    <label class="text-primary">Administration Center Version</label>
    <span class="">{{versionService.releaseVersionComputedSignal().version}}</span>
  </div>

  <p-accordion>
    <p-accordion-panel value="0" class="dialog-accordion">
      <p-accordion-header>Additional Information</p-accordion-header>
      <p-accordion-content>
        <div>
          <div class="flex justify-between py-2">
            <label class="text-primary">Pathfinder UI Version</label>
            <span class="">{{versionService.uiVersionComputedSignal().version}}</span>
          </div>

          <div class="flex justify-between py-2">
            <label class="text-primary">Pathfinder API Version</label>
            <span class="">{{versionService.pathfinderApiVersionComputedSignal().apiBuildVersion}}</span>
          </div>

          <div class="flex justify-between py-2">
            <label class="text-primary">Digital Media API Version</label>
            <span class="">{{versionService.digitalMediaApiVersionComputedSignal().apiBuildVersion}}</span>
          </div>

          <div class="flex justify-between py-2">
            <label class="text-primary">Auth API Version</label>
            <span class="">{{versionService.authApiVersionComputedSignal().apiBuildVersion}}</span>
          </div>

          <div class="flex justify-between py-2">
            <label class="text-primary">Reporting API Version</label>
            <span class="">{{versionService.reportingApiVersionComputedSignal().apiBuildVersion}}</span>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <div class="mt-6 pt-4 border-t border-white/10">
    <p class="mb-2 font-sans text-[12px] leading-relaxed">
      © 2023–2026 CODY Computer Services, Inc. (“CODY”) All rights reserved.
      <br />
      This software (object and source code) and all associated content (including video training and all documentation)
      contain proprietary and confidential information of CODY. Unauthorized use, reproduction, distribution,
      modification, or disclosure is prohibited.
    </p>
    <p class="m-0 font-sans text-[12px] leading-relaxed">
      The most current MSSA covering all CODY Software and Services can be found at the following location:
    </p>
    <div class="mt-2 flex">
      <span class="opacity-60 font-mono text-[12px] py-1 break-all">
        https://www.codysystems.com/site_assets/files/Legal/CODY_MSSA_and_Supporting_Documents.pdf
      </span>
    </div>
  </div>
</p-dialog>